// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__RDEw2","title":"Advt_title__6U1za","qrsWrapper":"Advt_qrsWrapper__0w6Jn","qrCode":"Advt_qrCode__CV6b5"};